export var ModalBodyVariant = /*#__PURE__*/function (ModalBodyVariant) {
  ModalBodyVariant["Default"] = "default";
  ModalBodyVariant["FullWidth"] = "full-width";
  return ModalBodyVariant;
}({});